<template>
  <div>
    <Head :title="`Заявка № ${order.id}`" />
    <div class="mb-8 flex max-w-3xl justify-start">
      <h1 class="text-3xl font-bold">
        <Link
          class="text-indigo-500 hover:text-indigo-600"
          :href="$routes.orders()"
        >
          Заявки
        </Link>
        <span class="font-medium text-indigo-400">/</span>
        {{ form.order.title }}
      </h1>
    </div>
    <trashed-message v-if="order.deleted_at" class="mb-6" @restore="restore">
      Заявка была удалена.
    </trashed-message>
    <div class="max-w-3xl overflow-hidden rounded bg-white shadow">
      <order-form
        v-model="form"
        :clients="clients"
        :workers="workers"
        :categories="categories"
        :statuses="statuses"
        @submit="submit"
      >
        <div
          class="flex items-center border-t border-gray-200 bg-gray-100 px-8 py-4"
        >
          <button
            v-if="!order.deleted_at"
            class="text-red-700 hover:underline"
            tabindex="-1"
            type="button"
            @click="destroy"
          >
            Удалить
          </button>
          <loading-button
            :loading="form.processing"
            class="btn-indigo ml-auto"
            type="submit"
          >
            Обновить
          </loading-button>
        </div>
      </order-form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3';
import Layout from '@/Layouts/Main.vue';
import LoadingButton from '@/Shared/LoadingButton.vue';
import OrderForm from './Form.vue';
import TrashedMessage from '@/Shared/TrashedMessage.vue';
import serializePhotos from '@/Shared/serializePhotos';
import omit from 'lodash/omit';

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    OrderForm,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    order: {
      type: Object,
      required: true,
    },
    clients: {
      type: Array,
      required: true,
    },
    categories: {
      type: Array,
      required: true,
    },
    statuses: {
      type: Array,
      required: true,
    },
    workers: {
      type: Array,
      required: true,
    },
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        order: omit(this.order, 'id', 'deleted_at', 'finish_at'),
      }),
    };
  },
  methods: {
    submit() {
      this.form
        .transform((data) => ({
          ...data,
          order: { ...data.order, photos: serializePhotos(data.order.photos) },
        }))
        .put(this.$routes.order(this.order.id), {
          preserveState: false,
          preserveScroll: true,
          onSuccess: () => {
            // Update the form with the new data from the response
            this.form.order = { ...this.form.order };
          },
        });
    },
    destroy() {
      if (confirm('Вы хотите удалить заявку?')) {
        this.$inertia.delete(this.$routes.order(this.order.id));
      }
    },
    restore() {
      if (confirm('Вы хотите восстановить заявку?')) {
        this.$inertia.put(this.$routes.restore_order(this.order.id));
      }
    },
  },
};
</script>
